/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-10-20 17:56:05
 * @LastEditTime: 2023-10-27 14:20:15
 * @LastEditors: WangYuhan
 */

import axios from './config';
import qs from 'qs';

export const prefix = '/rest/';
export const prefixShipper = 'shipper/api/';
export const prefixAi = '/api/ai-saas/';

// post默认请求
export function post(apiUrl, params, config = {}) {
  return axios.post(apiUrl, params, config);
}

// get默认请求
export function get(apiUrl, params) {
  return axios.get(apiUrl, {
    params: params,
  });
}

// get  请求json
export function getJson(apiUrl, params) {
  return axios.get(apiUrl, {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        arrayFormat: 'brackets',
      });
    },
  });
}

// delete默认请求
export function deleted(apiUrl, params) {
  return axios.delete(apiUrl, {
    params: params,
  });
}

// put默认请求
export function put(apiUrl, params) {
  return axios.put(apiUrl, params);
}
